<template>
    <div>
        <app-wysiwyg
            label="Überschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.title'"
            textpicker-namespace="aboutwidget/title"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Unterüberschrift"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.subtitle'"
            textpicker-namespace="aboutwidget/subtitle"
            required
            :maxlength="255"
            :slim="true"
        ></app-wysiwyg>

        <app-wysiwyg
            label="Text"
            :data-source="'tecpage.user.modules.' + moduleId + '.data.text'"
            textpicker-namespace="aboutwidget/text"
            :maxlength="1024"
        ></app-wysiwyg>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Wysiwyg from '@/components/fields/simple/Wysiwyg.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R005'),
            help: this.$helpers.uiText('R027'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-wysiwyg': Wysiwyg
    }
};
</script>
